class CollectionB2bSearch extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.input = null;
    this.categoryList = this.closest('.collection-b2b-outer')?.querySelector('collection-category-list');
    this.currentSort = window.location.search.includes('sort_by=')
      ? window.location.search.split('sort_by=')[1].split('&')[0]
      : 'relevance';
    this.lastSearchTerm = '';
  }

  connectedCallback() {
    this.form = this.querySelector('.collection-b2b-search__form');
    this.input = this.querySelector('.collection-b2b-search__input');
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }
  }

  performSearch(searchTerm) {
    const currentProductGrid = document.getElementById('ProductGridContainer');
    if (!searchTerm.length) return;

    const loadingOverlay = currentProductGrid.querySelector('.loading-overlay');
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    const url = `${this.form.action}?q=${encodeURIComponent(searchTerm)}&type=product&section_id=b2b-search&sort_by=${
      this.currentSort
    }`;
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProductGrid = doc.getElementById('ProductGridContainer');

        if (newProductGrid && currentProductGrid) {
          currentProductGrid.innerHTML = newProductGrid.innerHTML;
        }

        const collectionTitle = document.querySelector('.collection-b2b-header .h1');
        if (collectionTitle) {
          collectionTitle.textContent = `Search results for "${searchTerm}"`;
        }
      })
      .catch((error) => {
        console.error('Error fetching search results:', error);
        if (currentProductGrid) {
          currentProductGrid.innerHTML = `
            <div class="collection collection--empty page-width" id="product-grid">
              <div class="title-wrapper center">
                <h2 class="title title--primary">
                  Error loading search results. Please try again.
                </h2>
              </div>
            </div>
          `;
        }
      })
      .finally(() => {
        window.b2bSearchPerformed = true;
        if (loadingOverlay) loadingOverlay.classList.add('hidden');
        if (this.categoryList) this.categoryList.setupPaginationOuter();
        this.lastSearchTerm = searchTerm;
      });
  }

  onFormSubmit(event) {
    event.preventDefault();
    const searchTerm = this.input.value.trim();
    this.performSearch(searchTerm);
  }
}

customElements.define('collection-b2b-search', CollectionB2bSearch);
